// https://stackoverflow.com/questions/3550790/check-if-third-party-cookies-are-enabled
import React, { useState, useEffect } from "react";

const Footer = () => {
  const [thirdpartyCookie, setThirdpartyCookie] = useState(false);
  const [loaded, setLoaded] = useState(false);

 

  return (
    <footer className="p-3 text-center footer-main footer mt-auto ">
      <hr/>
      <div className="logo" />
      <p>&copy; {new Date().getFullYear()} OGW Group Trips </p>
    
    </footer>
  );
};

export default Footer;
